import React, {Component} from 'react';
import * as func from "../../../../utils/functions";
import ListItem from "./item/listItem";
import {BASE_PATH} from "../../../../wpconfig";
import {objectToQueryString, pushUrl} from "../../../../utils/functions";
import ReactPaginate from "react-paginate";

class mailReject extends Component {
  constructor(props) {
    super(props);
    const p = func.parseParams(location.search.substring(1))

    this.state = {
      isInit: false,
      param: {
        'current_page' : p['current_page'] ? p['current_page'] : 1,
        'record_id' : p['record_id'] ? p['record_id'] : '',
      },
      records: [],
      totalRecords: 0,
      totalPage: 0,
      action : 'sendmail/reject/list',
      url: 'wp-admin/admin.php?page=researchmind-analysis&tab_id=mailReject&',
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.getList({}, true)
    }, 0);
  }

  getList(param = {}, isInit = false) {
    if(Object.keys(param).length > 0) {
    } else {
      param = this.state.param
    }

    func.getData(this.state.action, param).then((response) => {
      const p = {
        records: response.records,
        totalRecords: response.pageInfo.totalResults,
        totalPage: response.pageInfo.totalPage,
      }
      if(isInit) {
        p['isInit'] = true
      } else {
        const url = objectToQueryString(this.state.param);
        pushUrl('검색', BASE_PATH + this.state.url + url, this.state.param);
      }
      this.setState(p)
    });
  }
  handlePageClick = (page) => {
    const paged = page.selected + 1;

    let param = this.state.param;
    param['current_page'] = paged;

    this.setState(param)

    this.getList(param);
  }

  render() {
    return (
        <div className="container-fluid mt-3 admin-layout">
          <div className="row">
            <div className="col admin-contents">
              <table className="table table-striped table-thin border-bottom sendmail-reject-list">
                <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">이메일</th>
                  <th scope="col">이름</th>
                  <th scope="col">연구자ID</th>
                  <th scope="col">비고</th>
                  <th scope="col">등록일자</th>
                </tr>
                </thead>
                <tbody>
                {!this.state.isInit && this.state.records.length <= 0 && <tr>
                  <td colSpan={6}>로딩중입니다.</td>
                </tr>}
                {this.state.isInit && this.state.records.length <= 0 && <tr>
                  <td colSpan={6}>결과가 없습니다.</td>
                </tr>}
                {this.state.records.map((record, index) => {
                  return (
                      <ListItem key={record.ID} record={record} url={BASE_PATH + this.state.url} />
                  )
                })}
                </tbody>
              </table>
              {this.state.totalPage > 1 &&
                  <div className="mt-4">
                    <div>
                      <div className="paging-wrap">
                        <ReactPaginate
                            forcePage={Number(this.state.param.current_page) - 1}
                            pageCount={this.state.totalPage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={2}
                            onPageChange={this.handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item page-item-prev'}
                            previousLinkClassName={'page-link'}
                            nextClassName={'page-item page-item-next'}
                            nextLinkClassName={'page-link'}
                        />
                      </div>
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
    )
  }
}

export default mailReject;
